import { render, staticRenderFns } from "./SetOriginPoint.vue?vue&type=template&id=14d3a620&scoped=true"
import script from "./SetOriginPoint.vue?vue&type=script&lang=js"
export * from "./SetOriginPoint.vue?vue&type=script&lang=js"
import style0 from "./SetOriginPoint.vue?vue&type=style&index=0&id=14d3a620&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14d3a620",
  null
  
)

export default component.exports